export default {"src":"/_next/static/media/Blogs-icon.cbb69ae8.svg","height":31,"width":28};